module.exports = __webpack_public_path__ + "img/about-us-01-hero-bg.f0eb863b.jpg";